import type { NamedFieldProps } from "./Field.js";
import { Field, useField } from "./Field.js";
import { FieldNotice } from "./FieldNotice.js";

export function CheckboxField(props: NamedFieldProps): React.ReactElement {
	const field = useField<boolean>(props);
	const { name, form, description, fullplaceholder, value } = field;
	return (
		<Field {...field} title="" description="">
			<label className="input space-none flex-row flex-middle gap-xsmall">
				<input //
					name={name}
					type="checkbox"
					defaultChecked={value}
					onChange={({ currentTarget }) => form.publish(name, currentTarget.checked)}
				/>
				<span>{fullplaceholder}</span>
			</label>
			<FieldNotice name={name} />
			{description ? <p className="color-quiet size-small space-xxsmall">{description}</p> : null}
		</Field>
	);
}
